import React from 'react';
import './TrustBar.css';

const TrustBar = () => {
  const trustPoints = [
    "DVSA-Approved Driving Instructors",
    "Automatic & Manual Lessons",
    "Flexible Lesson Times",
    "Intensive Driving Courses",
    "Over 15 Years of Experience",
    "Fully Insured Dual-Control Cars",
    "Pass Plus & Motorway Lessons"
  ];

  // Duplicate list to guarantee seamless, continuous infinite looping
  const marqueeItems = [...trustPoints, ...trustPoints];

  return (
    <section className="trust-bar-section py-4 border-top border-bottom">
      <div className="container-fluid px-0">
        {/* Star Rating Badge Header */}
        <div className="text-center mb-4 px-3">
          <div className="d-inline-flex align-items-center justify-content-center flex-wrap gap-2 px-4 py-2 bg-white rounded-pill shadow-sm border">
            <div className="d-flex text-warning fs-5">
              <i className="bi bi-star-fill me-1"></i>
              <i className="bi bi-star-fill me-1"></i>
              <i className="bi bi-star-fill me-1"></i>
              <i className="bi bi-star-fill me-1"></i>
              <i className="bi bi-star-fill"></i>
            </div>
            <span className="fw-bold text-dark fs-6 ms-1">
              Trusted by Learners Across Leicester
            </span>
          </div>
        </div>

        {/* Infinite Auto-Scroll Marquee */}
        <div className="trust-bar-marquee-wrapper py-2">
          <div className="trust-bar-track">
            {marqueeItems.map((point, index) => (
              <div key={index} className="trust-card-item">
                <div className="trust-check-badge">
                  <i className="bi bi-check-lg"></i>
                </div>
                <span className="fw-semibold text-dark fs-6">{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
